import { PaginationRequest } from "../../objects/pagination";
import { customFetch } from "../../utils/http";

export const getBanners = async (req: PaginationRequest) => {
  const queryParams = new URLSearchParams();
  queryParams.set("page", String(req.page));
  queryParams.set("size", String(req.size));
  if (req.search) queryParams.set("search", req.search);
  return await customFetch(
    `v1/banner?${queryParams}`,
    {
      method: "GET",
    }
  );
};

export const getBanner = async (id: string) => {
  return await customFetch(`v1/banner/${id}`, {
    method: "GET",
  });
};
export const createBanner = async (data: any) => {
  return await customFetch("v1/banner", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateBanner = async (id: string, data: any) => {
  return await customFetch(`v1/banner/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteBanner = async (id: string) => {
  return await customFetch(`v1/banner/${id}`, {
    method: "DELETE",
  });
};

